
































































































import { getPushSetting, setPushSettingApi } from "@/api/statistics";
import staffSelectDialog from "./staffSelectDialog.vue";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component({
  name: "pushSettingDialog",
  components: {
    staffSelectDialog,
  },
})
export default class extends Vue {
  dialogVisible: boolean = false;
  form = {
    push_time: "",
    staff_ids: [],
    staff_items: [],
  };
  rules = {
    push_time: [
      { required: true, message: "请选择推送时间", trigger: "change" },
    ],
    // staff_ids: [
    //   { required: true, message: "请选择推送人员", trigger: "change" },
    // ],
  };
  openDialog() {
    this.dialogVisible = true;
    getPushSetting().then((res: any) => {
      this.form.push_time = res.data.push_time.slice(0, 5);
      this.form.staff_items = res.data.staff;
      this.form.staff_ids = res.data.staff_ids;
    });
  }
  hideDialog() {
    this.dialogVisible = false;
  }
  handleSubmit() {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          setPushSettingApi({
            push_time: this.form.push_time + ":00",
            staff_ids: this.form.staff_ids,
          }).then(() => {
            this.$message({
              type: "success",
              message: "设置成功",
            });
            this.hideDialog();
          });
        }
      }
    );
  }
}
